export default __webpack_public_path__ + "static/media/logo_persian.6825942e.png";